import { NgModule } from '@angular/core';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { TmDateRangePickerComponent } from "@teammood/shared/ui/date-range-picker";
import { TmLanguageSelectComponent } from './language-select';
import { TmOutOfOfficeComponent } from './out-of-office';
import { TM_SLIDE_TOGGLE_PROVIDER } from './slide-toggle';
import { TmSlideToggleComponent } from '@teammood/shared/ui/slide-toggle';
import { TM_SNACK_BAR_PROVIDER } from './snack-bar';
import { TmTagsInputComponent } from './tags-input';
import { TmTimepickerComponent } from '@teammood/shared/ui/timepicker';
import { TmTimeZonePickerComponent } from './timezone-picker';
import { QuillModule } from "ngx-quill";
import EmojiBlot from "./rich-text-area/emoji-blot";
import GifBlot from "./rich-text-area/gif-blot";
import { PlainTextClipboard } from "./rich-text-area/plain-text-clipboard";

@NgModule({
  imports: [
    TmDateRangePickerComponent,
    TmLanguageSelectComponent,
    TmOutOfOfficeComponent,
    TmSlideToggleComponent,
    TmTagsInputComponent,
    TmTimepickerComponent,
    TmTimeZonePickerComponent,
    QuillModule.forRoot({
      customModules: [{
        implementation: EmojiBlot,
        path: 'formats/emoji'
      }, {
        implementation: GifBlot,
        path: 'formats/gif'
      }, {
        implementation: PlainTextClipboard,
        path: "modules/clipboard"
      }],
      suppressGlobalRegisterWarning: true
    }
    ),
  ],
  exports: [
    TmDateRangePickerComponent,
    TmLanguageSelectComponent,
    TmOutOfOfficeComponent,
    TmSlideToggleComponent,
    TmTagsInputComponent,
    TmTimepickerComponent,
    TmTimeZonePickerComponent
  ],
})
export class TmSharedUIModule {
}

export const TM_SHARED_UI_PROVIDERS = [
  TM_SLIDE_TOGGLE_PROVIDER,
  TM_SNACK_BAR_PROVIDER,
  {
    provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: {
      appearance: 'outline',
      subscriptSizing: 'dynamic'
    }
  },
]